import { NgModule } from '@angular/core';
import { SortDirective } from './sort-table.directive';

@NgModule({
  declarations: [SortDirective],
  exports: [SortDirective],
})
export class SortTableModule {}
